export let BASENAME;

export default (initialData) => {
	BASENAME = initialData['BASENAMEVARIABLE'];

	return BASENAME;
};
